import React from "react";
//css & images
import "./Toaster.css";
import closeIcon from "../Images/close-icon.svg";

const Toaster = () => {
    return (
        <>
            <div className="toaster hide" id="toaster">
                <h1 className="toaster-title" id="toasterTitle">Toaster title</h1>
                <div className="toaster-body" id="toasterBody">Your changes have successfully been saved</div>
                <img className="toaster-close-icon" src={closeIcon} alt="close-icon" id="toasterCloseIcon" />
            </div>
        </>
    )
}

function showToaster(type, titleText, bodyText) {
    if (type === 'error') {
        document.getElementById('toaster').style.borderColor = "#ae1536";
        document.getElementById('toasterTitle').style.color = "#ae1536";
    }
    document.getElementById('toasterTitle').innerHTML = titleText;
    document.getElementById('toasterBody').innerHTML = bodyText;
    document.getElementById('toaster').className = "toaster show-toaster-class";
    setInterval(() => { document.getElementById('toaster').className = "toaster hide-toaster-class"; }, 5000);
    document.getElementById('toasterCloseIcon').onclick = function () {
        document.getElementById('toaster').className = "toaster hide-toaster-class";
    }
}

export { Toaster, showToaster };